export interface IcSwitchChangeEventDetail {
  value: string | null;
  checked: boolean;
}
